import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });
export const EMAIL = "Support@866zerofees.com";
export const PHONE = "866-937-0333";
export const PHONE_HREF = "tel:+18669370333";

export const BENEFITS = [
  "Eliminate transaction fees",
  "Free equipment for qualifying merchants",
  "Dedicated account manager",
  "Real tech support",
  "Friendly customer service",
  "Transparent pricing",
];

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg ?? JSON.stringify(e)).join(" ");
  return detail?.msg ?? String(detail);
}

export const submitLead = (payload) => http.post("/leads", payload);
